import { createApp } from 'vue'
import { createPinia } from 'pinia'
import router from './router'
import App from './App.vue'
import './scss/main.scss'

// i18n setup
import i18n from './i18n'

// MSW setup for development
import { enableMocking } from './mocks'

const app = createApp(App)

app.use(createPinia())
app.use(router)
app.use(i18n)

// Start mocking conditionally and mount app
enableMocking().finally(() => {
    app.mount('#app')
})